export default {
      id: "link-member-usage",
      viewBox: "0 0 22 36",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#link-member",
      toString: function () {
        return this.url;
      }
    }